import Base from '../../js/_base';

export default class ProfileMain extends Base {
    get selectors() {
        return {
            dropdown: 'institution-dropdown',
        };
    }

    get elements() {
        return {
            dropdown: null,
        };
    }

    constructor(wrapper) {
        super();
        this.wrapper = wrapper;
        this.initialize();
        this.addEventListeners();
    }

    initialize() {
        super.initialize();
        this._elements.dropdown = document.getElementById(this._selectors.dropdown);
    }

    addEventListeners() {
        super.addEventListeners();
        this._elements.dropdown?.addEventListener('change', this.onDropdownChanged.bind(this));
    }

    onDropdownChanged() {
        const {value} = this._elements.dropdown;
        location.href = value;
    }
}
